import { animatePromotionTile, shouldAnimate } from "../lib/animation";

class PromotionTile extends HTMLElement {
  constructor() {
    super();
    this.selectors = {};
  }

  connectedCallback() {
    if (shouldAnimate(this)) {
      this.animatePromotionTile = animatePromotionTile(this);
    }
  }

  disconnectedCallback() {
    this.animatePromotionTile?.destroy();
  }
}

if (!customElements.get("promotion-tile")) {
  customElements.define("promotion-tile", PromotionTile);
}
